class OnloadImage {
  constructor() {
    this.init();

  }

  getCookie = (name) => {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length) === 'true';
    }
    return null;
  }
  setCookie = (name, value, hours) => {
    let date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    let expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  isPopUpOpen = () => {
    const onLoadImageWrapper = document.querySelector(".onload-image-container")
    if (!onLoadImageWrapper) return;
    const urlData = onLoadImageWrapper.getAttribute('data-url')
    let myBoolean = this.getCookie("myBoolean");

    if (myBoolean) {
      onLoadImageWrapper.classList.remove('active-onload-image')
    }
    else {
      if (window.location.href === "https://hilaryrhoda.in/") {
        onLoadImageWrapper.classList.add('active-onload-image')
      }
    }
    if (window.location.pathname === urlData) {
      if (onLoadImageWrapper) {
        onLoadImageWrapper.classList.remove('active-onload-image')
      }
    }
  }

  redirect = () => {
    const redirectBtn = document.querySelector(".onload-image-container .onload-re-direct-image")
    const redirectBtn2 = document.querySelector(".onload-image-container .button-wrapper.newsletter-compact__signup-button")
    if (redirectBtn) {
      redirectBtn.addEventListener("click", () => {
        this.setCookie('myBoolean', true, 2)
      })
    }
    if (redirectBtn2) {
      redirectBtn2.addEventListener("click", () => {
        this.setCookie('myBoolean', true, 2)
      })
    }

  }

  hideOnloadImage = () => {
    const closeBtn = document.querySelectorAll(".onload-image-container .onload-image-wrapper .onload-image-close-btn")
    const onLoadImageConatainer = document.querySelector(".onload-image-container")

    if (closeBtn.length > 0) {
      closeBtn.forEach((ele) => {
        ele.addEventListener("click", () => {
          if (onLoadImageConatainer) {
            onLoadImageConatainer.classList.remove('active-onload-image')
          }
        })
      })
    }

  }

  init() {
    this.isPopUpOpen()
    this.hideOnloadImage()
    this.redirect()
  }
}
document.addEventListener("DOMContentLoaded", function () {
  new OnloadImage();
})